// @ts-ignore
import * as elasticlunr from 'elasticlunr';
import './components/multi-select';
import './components/multi-select-item';

/**
 * Filter items on page based on ElasticLunr results.
 * Adds '--hidden' modifier class, normal priority.
 *
 * @param  {any} searchResults
 * @param  {NodeListOf<HTMLElement>} items
 * @param  {boolean=false} showAll
 */
function filterWithLunr(
  searchResults: any,
  items: NodeListOf<HTMLElement>,
  showAll: boolean = false,
): void {
  // Define hidden class
  const hiddenClass = 'werehiring__item--hidden';

  items.forEach((item) => {
    item.classList.toggle(hiddenClass, showAll);
  });

  // Loop over all search results
  searchResults.forEach((result) => {
    // Get the index of the element
    const resultIndex = parseInt(result.ref, 10);

    // Show target item
    items[resultIndex].classList.remove(hiddenClass);
  });
}

/**
 * Filters items on page based on selected items in field.
 * Adds '--force-hidden' modifier class, high priotiry.
 *
 * @param  {HTMLSelectElement} selectField
 * @param  {NodeListOf<HTMLElement>} items
 */
function filterWithTax(selectField: HTMLSelectElement, items: NodeListOf<HTMLElement>): void {
  // Define hidden class
  const hiddenClass = 'werehiring__item--force-hidden';

  // Get value set by user
  const { value } = selectField;
  const valueArray = value.split(',');

  console.table(valueArray);

  // Reset if no values selected
  if (valueArray.length === 0 || valueArray[0] === '') {
    items.forEach((item) => {
      item.classList.remove(hiddenClass);
    });

    return;
  }

  // Loop over items
  items.forEach((item) => {
    item.classList.add(hiddenClass);

    // Get tax set on item
    const { tax } = item.dataset;
    const taxJson: Array<string> = JSON.parse(tax);

    // Loop over all values
    valueArray.forEach((selectValue) => {
      // If value is set in item
      if (taxJson.includes(selectValue)) {
        // Remove forced hidden class
        item.classList.remove(hiddenClass);
      }
    });
  });
}

/**
 * Initiate the ElasticLunr search index and add all items to it.
 *
 * @param  {NodeListOf<HTMLElement>} searchItems
 * @returns {any} ElasticLunr search index
 */
function initLunrSearch(searchItems: NodeListOf<HTMLElement>): any {
  // Create the search index
  const searchIndex = elasticlunr(function defineSearch() {
    this.addField('title');
    this.addField('excerpt');
    this.addField('location');
    this.addField('hours');
    this.setRef('id');
  });

  // Loop over all items
  searchItems.forEach((item, index) => {
    // Construct the objects profile
    const searchProfile = {
      id: index,
      title: '',
      excerpt: '',
      location: '',
      hours: '',
    };

    // Get data from dom
    const titleElement = item.querySelector('.werehiring__job-title') as HTMLHeadElement;
    const excerptElement = item.querySelector(
      '.werehiring__job-description p',
    ) as HTMLParagraphElement;
    const locationElement = item.querySelector(
      '.werehiring-job-info__location span',
    ) as HTMLSpanElement;
    const hoursElement = item.querySelector('.werehiring-job-info__hours span') as HTMLSpanElement;

    // Fill in the profile
    searchProfile.title = titleElement.innerText;
    // searchProfile.excerpt = excerptElement.innerText;
    // searchProfile.location = locationElement.innerText;
    searchProfile.hours = hoursElement.innerText;

    // Add doc to index
    searchIndex.addDoc(searchProfile);
  });

  // Add select funtion
  const selectField = document.querySelector('werehiring-select') as HTMLSelectElement;
  selectField.addEventListener('bx-multi-select-selected', () => {
    console.log('test');
    filterWithTax(selectField, searchItems);
  });

  const searchField = document.querySelector('.werehiring-filter-bar input') as HTMLInputElement;
  const seachOptions = { expand: true, boolean: 'AND' };
  searchField.addEventListener('keyup', () => {
    const results = searchIndex.search(searchField.value, seachOptions);
    filterWithLunr(results, searchItems, searchField.value !== '');
  });

  // Return the search index
  return searchIndex;
}

// Initialize the search engine
initLunrSearch(document.querySelectorAll('.werehiring__item') as NodeListOf<HTMLElement>);
